import { memo, CSSProperties } from 'react';

import { Currencies } from '@constants/constants';
import { getCurrencySymbol } from '@utils/utils';
import { getNumberParts } from '@components/ui/price/utils';
import { OrginalPriceProps } from '@components/ui/price/type';

import Price from './Price';
import {
  StyledListingItemPriceLabel,
  PriceInEUR,
  StyledPriceFakePrice,
  OriginalPriceContainer,
} from './style';

const OriginalPrice = ({
  price,
  currency,
  size = 16,
  noLine,
  className,
  control,
  decimalShow,
}: OrginalPriceProps) => {
  if (price === undefined) return null;
  const [whole, decimals] = getNumberParts(price);
  return (
    <div className={className || ''}>
      {noLine ? (
        decimalShow ? (
          `${whole} ${getCurrencySymbol(currency)}`
        ) : (
          `${whole},${decimals} ${getCurrencySymbol(currency)}`
        )
      ) : (
        <OriginalPriceContainer size={size} noLine={control}>
          {decimalShow
            ? `${whole} ${getCurrencySymbol(currency)}`
            : `${whole},${decimals} ${getCurrencySymbol(currency)}`}
          {}
        </OriginalPriceContainer>
      )}
    </div>
  );
};

export interface ListingItemLabelProps {
  style?: CSSProperties;
  originalPrice?: number | string;
  priceWithDiscount?: number | string;
  currency?: string;
  priceInEUR?: number;
  rate?: number;
  total?: boolean;
}

const PriceLabel = ({
  originalPrice,
  priceWithDiscount,
  currency = Currencies.TL,
  priceInEUR,
  style,
  rate,
  total,
  ...otherProps
}: ListingItemLabelProps) => {
  return (
    <StyledListingItemPriceLabel style={style} {...otherProps}>
      {priceWithDiscount ? (
        <>
          {!originalPrice && !priceInEUR ? <StyledPriceFakePrice /> : null}
          {priceWithDiscount ? (
            <Price
              priceInEuro={priceInEUR ? true : false}
              priceInEUR={priceInEUR}
              total={total}
              showDecimal={false}
              originalPrice={
                originalPrice && !priceInEUR ? Number(originalPrice) : undefined
              }
              price={Number(priceWithDiscount)}
              originalPriceCurrency={getCurrencySymbol(currency)}
            >
              {rate && rate > 0 ? (
                <OriginalPrice
                  price={+originalPrice}
                  currency={getCurrencySymbol(currency)}
                  noLine={false}
                  decimalShow={true}
                />
              ) : null}
              {priceInEUR ? (
                <PriceInEUR fontSize={total}>
                  <OriginalPrice
                    price={priceInEUR}
                    currency={getCurrencySymbol(currency)}
                    noLine={true}
                    decimalShow={true}
                  />
                </PriceInEUR>
              ) : null}
            </Price>
          ) : null}
        </>
      ) : null}
    </StyledListingItemPriceLabel>
  );
};

export default memo(PriceLabel);
